import axios from "axios";

import type { AuthStatus, CompanyProvider, User } from "@virtual-brain-lib/types";

import env from "../environments";

export interface AuthMethod {
	type: "password" | "oauth" | "oidc";
	provider?: CompanyProvider;
	ssoUrl?: string;
}

export interface IdentifyResponse {
	status: "known" | "unknown" | "unknown-with-sso";
	companyLogo?: string;
	methods?: AuthMethod[];
}

export async function login(email: string, password: string, captchaToken?: string | undefined) {
	const response = await axios.post<User>(`${env.apiUrl}/auth/login`, {
		email,
		password,
		captchaToken,
	});

	return response.data;
}

export async function signup(name: string, email: string, password: string) {
	const response = await axios.post<User>(`${env.apiUrl}/auth/signup`, {
		name,
		email,
		password,
	});

	return response.data;
}

export async function getUserStatus() {
	axios.defaults.withCredentials = true;
	const response = await axios.get<AuthStatus>(`${env.apiUrl}/auth/status`);

	return response.data;
}

export async function logout() {
	await axios.post(`${env.apiUrl}/auth/logout`);
}

export async function resetPasswordEmail(email: string) {
	await axios.post(`${env.apiUrl}/auth/reset-password`, { email });
}

export async function resetPassword(token: string, password: string) {
	await axios.post(`${env.apiUrl}/auth/reset-password/${token}`, { password });
}

export async function identifyEmail(email: string) {
	const response = await axios.post<IdentifyResponse>(`${env.apiUrl}/auth/identify`, { email });

	return response.data;
}
